import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";
import { useParams } from "react-router";

const DuplicateFileDataLibrary = ({ Show, Hide, Title, getEditorProjectData, projectData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [previousTitle, setPreviousTitle] = useState("");
  const [previousDescription, setPreviousDescription] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const { studyId } = useParams()

  const duplicateDataEDCEditorFileAndDataset = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Change Duplicate of this File?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, duplicate it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        let data
        if (projectData?.keepFile !== "system") {
          userData.studyId = studyId;
          userData.fileId = projectData?.uniqueId;
          userData.name = title;
          userData.description = description;
          userData.type = "file";
          data = await editorProjectServices.duplicateDataEDCEditorFileAndDataset(
            userData
          );
        } else {
          userData.fileName = `${projectData?.name}${projectData?.oldExtension}`;
          userData.newName = `${title}${projectData?.oldExtension}`;
          userData.folderPath = `${projectData?.localPath}`;
          data = await editorProjectServices.duplicateLocalFile(
            userData
          );
        }
        setButtonLoader(false)
        if (data?.statusCode === 200) {
          getEditorProjectData();
          setTitle("")
          setDescription("")
          setError("")
          Hide()
        }
      }
    });
  };

  const validateFileTitle = (input) => {
    const fileTitleRegex = /^[a-zA-Z0-9_]+$/;

    if (!fileTitleRegex.test(input)) {
      setError(
        "File Title should only contain capital letters, small letters, or numbers"
      );
    } else {
      setError("");
    }
  };

  useEffect(() => {
    setPreviousTitle(projectData?.name);
    setPreviousDescription(projectData?.description);
    setTitle(projectData?.name);
    setDescription(projectData?.description);
  }, [projectData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Title{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                validateFileTitle(e.target.value);
              }}
              placeholder="Enter File Title"
              className={previousTitle === title && "border-danger"}
              required
            />
            {error && (
              <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
                File Title should only contain capital letters, small letters,
                underScore, and numbers "Space Not Allowed"
              </span>
            )}
          </Form.Group>
          {projectData?.keepFile !== "system" &&
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                Description{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Enter File Description"
                className={previousDescription === description && "border-danger"}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Form.Group>
          }
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            disabled={
              projectData?.keepFile !== "system" ?
                (buttonLoader || !title || !description)
                :
                (buttonLoader || !title)
            }
            title={Title}
            className="updateProfile"
            onClick={() => {
              duplicateDataEDCEditorFileAndDataset();
            }}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Duplicating...
              </div>
            ) : (
              "Duplicate"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default DuplicateFileDataLibrary;
